import React from 'react';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { volumes, insideEveryVolume } from '../data/volumes';
import { CtaButton } from './CtaButton';
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="w-full bg-white" data-id="element-277" data-mp="184ey7rx3ey2q">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-278" data-mp="1c5gsrvg2elyd">
        <h2 id="volumes-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl" data-id="element-279" data-mp="1c5ql3pol1578">
          Six volumes. One system. Nothing to improvise.
        </h2>

        <ol className="mt-10 space-y-4" data-id="element-280" data-mp="24tcujekhr420">
          {volumes.map(volume => {
          const featured = Boolean(volume.flag);
          return <li key={volume.number} className={featured ? 'rounded-2xl bg-sage-tint border border-sage-soft p-6 sm:p-8' : 'rounded-2xl border border-cream-dark p-6 sm:p-8'} data-id="element-281" data-mp="1vsoigpenrdrr">
                <div className="grid sm:grid-cols-[7.5rem_1fr] gap-y-4 sm:gap-x-8" data-id="element-282" data-mp="3o7ddb4hzuqna">
                  <div data-id="element-283" data-mp="3j9bxcsfv77g1">
                    <p className="font-serif font-bold text-sm text-sage tracking-[0.14em] uppercase" data-id="element-284" data-mp="3ja53br701sx4">
                      Volume {volume.number}
                    </p>
                    {volume.flag && <p className="mt-2 text-[11px] font-bold uppercase tracking-wider text-terracotta" data-id="element-285" data-mp="3t6gl2wpczayy">
                        {volume.flag}
                      </p>}
                  </div>

                  <div data-id="element-286" data-mp="62a3x7kzvsh2">
                    <h3 className="font-serif font-bold text-xl sm:text-2xl text-ink leading-snug" data-id="element-287" data-mp="60phk58u3fua">
                      {volume.title}
                    </h3>
                    <p className="mt-1 font-serif italic text-ink-muted" data-id="element-288" data-mp="fsvc9mqh0bd6">
                      {volume.subtitle}
                    </p>
                    <p className="mt-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-289" data-mp="pqj7edrznkvv">
                      {volume.body}
                    </p>
                    <p className="mt-4 flex gap-2 font-semibold text-ink" data-id="element-290" data-mp="wused3szzrgz">
                      <ArrowRightIcon className="w-4 h-4 mt-1 text-sage shrink-0" aria-hidden="true" data-id="element-291" data-mp="11saqf32bamt7" />
                      <span data-id="element-292" data-mp="16q2h5tr802vt">{volume.promise}</span>
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-10 rounded-2xl bg-cream border border-cream-dark p-6 sm:p-8" data-id="element-293" data-mp="1fjz2558nf99n">
          <p className="font-serif font-bold text-ink text-lg" data-id="element-294" data-mp="1khqshutnanbq">
            Inside every volume
          </p>
          <ul className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" data-id="element-295" data-mp="1pj6dxnzqivun">
            {insideEveryVolume.map(item => <li key={item} className="flex gap-2.5 text-[15px] text-ink-soft" data-id="element-296" data-mp="3r9rmh00a71zd">
                <CheckIcon className="w-4 h-4 mt-[5px] text-vital shrink-0" aria-hidden="true" data-id="element-297" data-mp="3rbunsg6vwhje" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="mt-10 flex" data-id="element-298" data-mp="28n9suwih16oc">
          <CtaButton data-id="element-299" data-mp="28m8b696y9lxn">I want the complete system</CtaButton>
        </div>
      </div>
    </section>;
}